module.exports = __webpack_public_path__ + "img/landing-btn-linkedin-icon.dfbec61b.svg";